import { AuditAction } from '@core/entities/audit/AuditResult/types'
import { IUser } from '@core/entities/user'
import { GeoJSON } from 'geojson'
import { getMediaUrlContentType } from '@core/react-query/helpers/mediaHelpers'
import { IAuditResultMetadata } from '@core/entities/audit/AuditResult/IAuditResultMetadata'
import { IAuditDraftResult } from '@core/entities/audit/AuditResult/IAuditDraftResult'
import { IAuthGroup } from '@core/entities/Groups/AuthGroups'

export const attachAuditResultMediaTypes = async (audit: IAuditResult) => {
  if (!audit.metadata?.attachments) return
  await Promise.all(
    audit.metadata.attachments.map(async (attachment) => {
      attachment.contentType = await getMediaUrlContentType(attachment.getUrl)
    }),
  )
}

export interface IAuditResult {
  id: number
  createdOn: string
  platform: 'WEB' | 'ANDROID' | 'IOS' | 'UNKNOWN'
  action: AuditAction
  signatureUrl?: string
  info?: string
  user?: IUser
  organisationUser?: IUser
  projectUser?: IUser
  metadata?: IAuditResultMetadata
  geoJSON?: GeoJSON
  coordinates?: {
    latitude: number
    longitude: number
    locationAccuracyInMeters?: number
    locationAccuracyStatus?: string
  }
  project?: {
    id: number
    name: string
  }
  organisation?: {
    id: number
    name: string
  }
  permit?: {
    id: number
    shortUUID: string
    templateName: string
  }
  checklist?: {
    id: number
    shortUUID: string
    templateName: string
  }
  register?: {
    id: number
    name: string
  }
  registerItem?: {
    id: number
    uniqueId: string
  }
  permitTemplate?: {
    id: number
    name: string
  }
  permitTemplateVersion?: {
    id: number
    version: number
  }
  checklistTemplate?: {
    id: number
    name: string
  }
  checklistTemplateVersion?: {
    id: number
    version: number
  }
  siteboxDocument?: {
    id: number
    name: string
  }
  siteboxDocumentVersion?: {
    id: number
    name: string
    documentVersion: number
  }
  appliedToGroups?: Array<IAuthGroup>
  permitDraft?: IAuditDraftResult
  checklistDraft?: IAuditDraftResult
}
